import React from 'react';
import { Input } from 'formik-antd';
import FormControl from '~/components/Form/FormControl';
import Row from '~/components/Row';
import { useTranslation } from 'react-i18next';

export default function TaxesSection({ fluidPermissions }) {
  const { t } = useTranslation();

  return (
    <Row>
      <FormControl cols={{ sm: 6, xs: 12 }} label={t('Taxa de antecipação (%)')} field="anticipation_fee">
        <Input name="anticipation_fee" disabled={!fluidPermissions()} />
      </FormControl>
      <FormControl cols={{ sm: 6, xs: 12 }} label={t('Taxa débito do cliente (%)')} field="debit_fee">
        <Input name="debit_fee" disabled={!fluidPermissions()} />
      </FormControl>
      <FormControl cols={{ sm: 6, xs: 12 }} label={t('Taxa crédito do cliente (%)')} field="credit_fee">
        <Input name="credit_fee" disabled={!fluidPermissions()} />
      </FormControl>
      <FormControl cols={{ sm: 6, xs: 12 }} label={t('Taxa pix do cliente (%)')} field="pix_fee">
        <Input name="pix_fee" disabled={!fluidPermissions()} />
      </FormControl>
    </Row>
  );
}
